import Model from "../Model";

class RepresentantbubblesZone extends Model{

    buildUrl ({ param }) {
        return ['employeeview/dataemployeebyzone', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new RepresentantbubblesZone;